// Generated by tools/about-stats.js — do not edit.
//
// What each school's syllabi, briefs and questions add up to, as of the last run. The About
// pages and the landing page paint from this at once and then correct it from the server, so
// these are a starting point rather than the truth; see the header of that tool.

export const SERVER_STATS = {
  "NIFE": {
    "weeks": [
      {
        "weeks": 8,
        "label": "Calendar Weeks",
        "names": [
          "NIFE Syllabus"
        ]
      }
    ],
    "syllabi": [
      {
        "id": "nife-flight",
        "name": "NIFE Syllabus",
        "discussItems": 43
      }
    ],
    "briefs": [
      {
        "aircraft": "C172",
        "unit": "NIFE"
      }
    ],
    "questions": 437
  },
  "Primary": {
    "weeks": [
      {
        "weeks": 28,
        "label": "Production Weeks",
        "names": [
          "Delta Syllabus",
          "Echo Syllabus"
        ]
      }
    ],
    "syllabi": [
      {
        "id": "delta-primary",
        "name": "Delta Syllabus",
        "discussItems": 492
      },
      {
        "id": "echo-syllabus-primary-76ae",
        "name": "Echo Syllabus",
        "discussItems": 478
      }
    ],
    "briefs": [
      {
        "aircraft": "T-6B",
        "unit": "TW-4"
      },
      {
        "aircraft": "T-6B",
        "unit": "TW-5"
      },
      {
        "aircraft": "T-6B",
        "unit": "VT-3"
      },
      {
        "aircraft": "T-6B",
        "unit": "TW-4"
      },
      {
        "aircraft": "T-6B",
        "unit": "VT-3"
      }
    ]
  },
  "Advanced": {
    "weeks": [
      {
        "weeks": 19,
        "label": "Production Weeks",
        "names": [
          "E-2D"
        ]
      },
      {
        "weeks": 23,
        "label": "Production Weeks",
        "names": [
          "P-8",
          "E-6",
          "C-130",
          "USCG",
          "Tilt-Rotor"
        ]
      }
    ],
    "syllabi": [
      {
        "id": "t44c-e2d",
        "name": "T-44C E-2D",
        "discussItems": 481
      },
      {
        "id": "t44c-p8",
        "name": "T-44C P-8",
        "discussItems": 621
      }
    ],
    "briefs": [
      {
        "aircraft": "T-44C",
        "unit": "TW-4"
      }
    ]
  },
  "T-54A": {
    "weeks": [
      {
        "weeks": 20,
        "label": "Production Weeks",
        "names": [
          "T-54A"
        ]
      }
    ],
    "syllabi": [
      {
        "id": "t54a-me",
        "name": "T-54A",
        "discussItems": 383
      }
    ],
    "briefs": [
      {
        "aircraft": "T-54A",
        "unit": "VT-35"
      }
    ]
  },
  "TH-73A": {
    "weeks": [
      {
        "weeks": 39,
        "label": "Production Weeks",
        "names": [
          "COPT-R/CORPS"
        ]
      },
      {
        "weeks": 37,
        "label": "Production Weeks",
        "names": [
          "SNA"
        ]
      },
      {
        "weeks": 19,
        "label": "Production Weeks",
        "names": [
          "Tilt-Rotor"
        ]
      }
    ],
    "syllabi": [
      {
        "id": "th73a-coptr",
        "name": "TH-73A COPT-R/CORPS",
        "discussItems": 685
      },
      {
        "id": "th73a-sna",
        "name": "TH-73A SNA",
        "discussItems": 660
      },
      {
        "id": "th73a-tr",
        "name": "TH-73A Tilt-Rotor",
        "discussItems": 346
      }
    ],
    "briefs": [
      {
        "aircraft": "TH-73A",
        "unit": "TW-5"
      },
      {
        "aircraft": "TH-73A",
        "unit": "TW-5"
      },
      {
        "aircraft": "TH-73A",
        "unit": "TW-5"
      }
    ]
  }
};
